import React, { ReactNode } from 'react'
import { cn } from 'src/lib/utils'

interface WorkoutCardContentProps {
  children: ReactNode
  className?: string
}

export const WorkoutCardContent = ({ children, className }: WorkoutCardContentProps): React.ReactElement => {
  return <div className={cn('relative flex flex-col justify-between h-full p-3', className)}>{children}</div>
}
